// tools function
import array from "./array";
import files from "./files";
import image from "./images";
import local from "./local";
import numbers from "./numbers";
import system from "./system";
import text from "./text";
import time from "./time";
export default {
  files, 
  array, 
  image,
  numbers,
  system,
  text,
  time,
  local,
}